import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import translationEN from './locales/en.json';
import translationIT from './locales/it.json';
import translationFR from './locales/fr.json';
import translationES from './locales/es.json';
import translationDE from './locales/de.json';

const resources = {
    en: {
        translation: translationEN,
    },
    it: {
        translation: translationIT,
    },
    fr: {
        translation: translationFR,
    },
    es: {
        translation: translationES,
    },
    de: {
        translation: translationDE,
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        supportedLngs: ['en', 'it', 'fr', 'es', 'de'],
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n; 